import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'reactstrap';

import applePayIcon from 'assets/icons/apple-pay.svg';
import styles from './styles.module.scss';

const ApplePayBanner = ({ onClose }) => (
  <Alert color="primary" className={`${styles.applePayBanner} text-center position-relative`}>
    <div className="d-flex align-items-center justify-content-center">
      <img width={50} src={applePayIcon} alt="Apple Pay" />
      <strong>Now Accepting Apple Pay</strong>
      <span className={styles.description}>
        Apple Pay is an easy and secure way to pay on LendingUSA in Safari.
      </span>
    </div>
    {onClose ? (
      <button
        type="button"
        className={styles.close}
        aria-label="Close"
        onClick={onClose}
      >
        <span aria-hidden="true">
          ×
        </span>
      </button>
    ) : null}
  </Alert>
);

ApplePayBanner.propTypes = {
  onClose: PropTypes.func,
};

ApplePayBanner.defaultProps = {
  onClose: null,
};

export default ApplePayBanner;
